import type { Translations } from '../types';

export const he: Translations = {
  common: {
    home: 'ראשי',
    about: 'אודות',
    contact: 'צור קשר',
    cart: 'עגלת קניות',
    wishlist: 'מועדפים',
    profile: 'אזור אישי',
    login: 'התחברות',
    logout: 'התנתקות',
    search: 'חיפוש',
    menu: 'תפריט',
    close: 'סגור',
    back: 'חזרה',
    next: 'הבא',
    previous: 'הקודם',
    loading: 'טוען...',
    error: 'שגיאה',
    success: 'הצלחה',
    save: 'שמור',
    cancel: 'ביטול',
    delete: 'מחק',
    edit: 'ערוך',
    add: 'הוסף',
    remove: 'הסר',
    viewAll: 'צפייה בהכל',
    readMore: 'קרא עוד',
    learnMore: 'למד עוד',
    giftCard: 'GiftCard',
    customerService: 'שירות לקוחות',
    faq: 'שאלות נפוצות',
    sizeGuide: 'מדריך מידות',
    tradeIn: 'Alice Trade In',
    trackOrder: 'מעקב אחרי תיקונים',
    categories: 'קטגוריות',
  },
  product: {
    addToCart: 'הוסף לסל',
    addedToCart: 'נוסף לסל',
    outOfStock: 'אזל מהמלאי',
    inStock: 'במלאי',
    price: 'מחיר',
    quantity: 'כמות',
    size: 'מידה',
    color: 'צבע',
    description: 'תיאור',
    details: 'פרטים',
    reviews: 'ביקורות',
    relatedProducts: 'מוצרים דומים',
    noProductsFound: 'לא נמצאו מוצרים',
    selectOption: 'בחר אפשרות',
    selectSize: 'בחר מידה',
    selectColor: 'בחר צבע',
  },
  cart: {
    title: 'עגלת הקניות',
    empty: 'העגלה ריקה',
    itemsInCart: 'פריטים בעגלה',
    subtotal: 'סכום ביניים',
    total: 'סה״כ',
    checkout: 'לתשלום',
    continueShopping: 'המשך קניות',
    removeItem: 'הסר פריט',
    updateQuantity: 'עדכן כמות',
    proceedToCheckout: 'המשך לתשלום',
  },
  auth: {
    signIn: 'התחברות',
    signUp: 'הרשמה',
    signOut: 'התנתקות',
    email: 'אימייל',
    password: 'סיסמה',
    confirmPassword: 'אימות סיסמה',
    forgotPassword: 'שכחת סיסמה?',
    resetPassword: 'איפוס סיסמה',
    createAccount: 'יצירת חשבון',
    alreadyHaveAccount: 'כבר יש לך חשבון?',
    dontHaveAccount: 'אין לך חשבון?',
    welcomeBack: 'ברוכים השבים',
    personalArea: 'האזור האישי',
  },
  footer: {
    about: 'אודות',
    shipping: 'משלוחים',
    returns: 'החזרות',
    privacy: 'מדיניות פרטיות',
    terms: 'תנאי שימוש',
    accessibility: 'נגישות',
    cookies: 'ניהול עוגיות',
    contactUs: 'צור קשר',
    followUs: 'עקבו אחרינו',
    newsletter: 'הירשמו לניוזלטר',
    newsletterPlaceholder: 'הזן את כתובת המייל שלך',
    subscribe: 'הרשמה',
    subscribed: 'נרשמת בהצלחה!',
    importantLinks: 'קישורים חשובים',
    copyright: '© כל הזכויות שמורות',
  },
  newsletter: {
    title: 'הישארו מעודכנים',
    subtitle: 'הירשמו לניוזלטר שלנו וקבלו עדכונים על מבצעים והטבות',
    placeholder: 'כתובת אימייל',
    button: 'הרשמה',
    success: 'נרשמת בהצלחה לניוזלטר!',
    error: 'אירעה שגיאה, נסה שוב',
    consent: 'אני מסכים/ה לקבל עדכונים ומבצעים',
  },
  cookies: {
    bannerTitle: 'אנו משתמשים בעוגיות',
    bannerText: 'אתר זה משתמש בעוגיות כדי לשפר את חוויית הגלישה שלכם.',
    accept: 'קבל הכל',
    reject: 'דחה הכל',
    customize: 'התאמה אישית',
    preferencesTitle: 'ניהול העדפות עוגיות',
    necessary: 'עוגיות הכרחיות',
    necessaryDesc: 'עוגיות אלו נחוצות לתפקוד האתר ואינן ניתנות לביטול.',
    analytics: 'עוגיות אנליטיקה',
    analyticsDesc: 'עוזרות לנו להבין כיצד מבקרים משתמשים באתר.',
    marketing: 'עוגיות שיווקיות',
    marketingDesc: 'משמשות להצגת פרסומות רלוונטיות עבורכם.',
    savePreferences: 'שמור העדפות',
  },
  errors: {
    generic: 'משהו השתבש. נסו שוב.',
    notFound: 'העמוד לא נמצא',
    unauthorized: 'אין לך הרשאה לצפות בתוכן זה',
    networkError: 'שגיאת רשת. בדקו את החיבור לאינטרנט.',
    tryAgain: 'נסה שוב',
  },
  seo: {
    defaultTitle: 'Alice Jewellery - תכשיטים ושעונים',
    defaultDescription: 'חנות התכשיטים והשעונים הטובה בישראל. מגוון רחב של תכשיטי זהב, יהלומים ושעונים.',
  },
};
